import React from "react";
import logoImage from "../../images/NWP-logo.webp";
import ContentContainer from "../container/ContentContainer";
import ScrollTop from "../controls/ScrollTop";
import { NavLogo } from "../controls/Navigation";
import { Link } from "gatsby";
import RequestQuote from "../controls/RequestQuote";
import SocialButtons from "../controls/SocialButtons";
import SubscribeForm from "../forms/SubscribeForm";

const Footer = ({ enableRequestQuote = false }) => {
  return (
    <>
      <ContentContainer
        containerClassName="w-full bg-gray4 flex justify-center p-4 pt-10 lg:pb-10 lg:px-20 "
        className="text-white w-full flex flex-col items-center justify-center lg:space-y-10"
      >
        <div className="flex flex-col lg:flex-row w-full lg:w-1000px">
          <div className="hidden lg:flex flex-col space-y-1 w-full lg:w-3/12 items-center md:items-start pb-10 md:pb-0">
            <NavLogo image={logoImage} width="100px" />
            <p>National Wood Products</p>
            <p>1 Latitude Way,</p>
            <p>Corona, CA 92881</p>
            <p>(909) 287-7906</p>
          </div>
          <div className="flex flex-col w-full lg:w-3/12 gap-y-4 pb-10 lg:pb-0">
            <p className="hidden lg:block font-bold text-center sm:text-left">
              LEARN MORE
            </p>
            <div className="flex flex-row lg:flex-col gap-4 justify-center">
              <Link className="button-action" to="/">
                Home
              </Link>
              <Link className="button-action" to="/about">
                About
              </Link>
              <Link className="button-action" to="/blog">
                Blog
              </Link>
              <Link className="button-action" to="/jobs">
                Jobs
              </Link>
              <Link className="button-action" to="/contact">
                Contact
              </Link>
            </div>
          </div>
          <div className="flex flex-col w-full lg:w-3/12 space-y-4 pb-0 items-center lg:items-start">
            <p className="font-bold text-center sm:text-left">PRODUCTS</p>
            <Link className="button-action" to="/products/textured-melamine">
              Textured Melamine
            </Link>
            <Link className="button-action" to="/products/hardwood-plywood">
              Hardwood Plywood
            </Link>
            <Link className="button-action" to="/products/hardwood-lumber">
              Hardwood Lumber
            </Link>
            <Link className="button-action" to="/products/mdf">
              MDF Products
            </Link>
            <Link className="button-action" to="/products/lacquered-boards">
              Lacquered Panels
            </Link>
            <Link className="button-action" to="/products/melamine-panels">
              Melamine Panels
            </Link>
          </div>
          <div className="flex flex-col w-full lg:w-3/12 space-y-4 pb-10 lg:pb-0">
            <p className="hidden sm:block font-bold text-center lg:text-left">
              FOLLOW US
            </p>
            <div className="pt-20 flex flex-row space-x-2 justify-center items-center">
              <SocialButtons
                type="fb"
                link="https://www.facebook.com/NationalWoodProductsIncSoCal/"
              />
              <SocialButtons
                type="linkedin"
                link="https://www.linkedin.com/company/18113261/"
              />
              <SocialButtons
                type="twitter"
                link="https://twitter.com/nwpsocal"
              />
              <SocialButtons
                type="insta"
                link="https://www.instagram.com/nwpsocal/"
              />
              <SocialButtons
                type="pinterest"
                link="https://www.pinterest.com/nwpsocal/"
              />
              <SocialButtons
                type="houzz"
                link="https://www.houzz.com/pro/nwpsocallb/national-wood-products"
              />
            </div>
            <SubscribeForm
              buttonClassName="bg-actionBlue text-white text-4xl p1"
              title="Get email updates"
              placeHolderClassName="placeholder-gray-500"
            />
          </div>

          <div className="flex lg:hidden flex-col space-y-1 w-full items-center pb-10 mt-10 text-sm sm:text-base">
            <NavLogo image={logoImage} width="100px" />
            <p className="pt-4">National Wood Products</p>
            <p>1 Latitude Way,</p>
            <p>Corona, CA 92881</p>
            <p>(909) 287-7906</p>
          </div>
        </div>
      </ContentContainer>
      <ScrollTop />
      {enableRequestQuote && <RequestQuote link="/contact" />}
    </>
  );
};

export default Footer;
